<template>
    <CContainer class="d-flex content-center min-vh-100">
        <CRow>
            <CCol>
                <CCardGroup>
                    <CCard class="p-4">
                        <CCardBody>
                            <CForm v-on:keyup.enter="login()">
                              <img v-if="get_access('login_image')" width="120px" height="auto" src="/login_image.png"/>
                                <h4 class="mt-3">{{ $t('components.login') }}</h4>
<!--                                <p class="">{{ $t('components.loginToPanel') }}</p>-->
                                <CInput
                                        :placeholder="$t('components.userName')"
                                        autocomplete="username email"
                                        v-model="user"
                                >
                                    <template #prepend-content>
                                        <CIcon name="cil-user"/>
                                    </template>
                                </CInput>
                                <CInput
                                        :placeholder="$t('components.password')"
                                        type="password"
                                        v-model="pass"
                                        autocomplete="curent-password"
                                >
                                    <template #prepend-content>
                                        <CIcon name="cil-lock-locked"/>
                                    </template>
                                </CInput>
                                <CRow>
                                    <CCol col="12" class="text-center">


                                        <CButton color="primary" v-on:click="login()" class="px-4">
                                            <CSpinner v-if="loading" size="sm"/>
                                            {{ $t('components.login') }}
                                        </CButton>
                                        <CRow class="mt-3">

                                            <label @click="forgot_password_modal=true">{{ $t('forgotPassword') }}</label>
                                        </CRow>
                                    </CCol>
                                    <CCol col="6" class="text-right">
                                    </CCol>
                                </CRow>
                            </CForm>
                        </CCardBody>
                    </CCard>
                </CCardGroup>
            </CCol>
        </CRow>
        <Modals ref="modal"/>
        <CModal
                :title="$t('forgotPassword')"
                color="danger"
                :show.sync="forgot_password_modal"
        >
           <CRow>
               <CCol>
                   <CInput
                       :placeholder="$t('mobileNoOrEmail')"
                       v-model="forgot_password_number"
                       />
               </CCol>
           </CRow>
            <template #footer>
                <CButton @click="forgot_password_modal = false,forgot_password()" color="dark">{{$t('buttons.ok')}}</CButton>
                <CButton @click="forgot_password_modal = false" color="dark">{{$t('buttons.cancel')}}</CButton>
            </template>
        </CModal>

    </CContainer>

</template>


<script>
    import axios from "axios";
    import Modals from "../panel/includes/Modals";

    export default {
        name: 'Login',
        data() {
            return {
                user: '',
                pass: '',
                forgot_password_modal:false,
                forgot_password_number: '',
                loading: false,
            }
        },
        components: {
            Modals
        },
        mounted() {
            // var json = {
            //
            // }
            // var keys = [];
            // for(var k in json) keys.push(k);
            // for(var ka=0; ka< keys.length;ka++){
            //   var str = json[keys[ka]];
            //   const arr = str.split(" ");
            //
            //   for (var i = 0; i < arr.length; i++) {
            //     arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
            //
            //   }
            //   const str2 = arr.join(" ");
            //   json[keys[ka]] = str2;
            //
            //
            // }
            // console.log(JSON.stringify(json))

        },
        methods: {

            goRegister() {
                this.$router.push({path: '/register'});
            },
            login() {

                let self = this;
                self.loading = true;

                let url = "token";
                const formData = new FormData();

                formData.append('username', this.user);
                formData.append('password', this.pass);

                delete axios.defaults.headers.post["Authorization"];
                axios.post(url, formData, {}).then((res) => {
                    self.loading = false;

                    // console.log(res.headers.value('token'));
// res.headers.value('token');
                    if (res.data.statusCode != 0) {
                        self.$refs.modal.show_api_response_modals( res);
                        console.log("not success");
                    } else {
                        console.log("last url " + localStorage.getItem('last_url'));


                        localStorage.setItem('mobile', self.user);
                        localStorage.setItem('user_name', res.data.data.userName);
                        localStorage.setItem('user_id', res.data.data.userId);
                        localStorage.setItem('token', res.data.data.tokenText);
                        localStorage.setItem("app_logo", localStorage.getItem("api_address") + res.data.data.logo)
                        localStorage.setItem('branchName', res.data.data.branchName);
                        localStorage.setItem('branchCode', res.data.data.branchCode);
                        localStorage.setItem('branchId', res.data.data.branchId);
                        localStorage.setItem('businessName', res.data.data.businessName);
                        // if (localStorage.getItem('last_url') == null) {
                            self.$router.push({path: '/dashboard'});
                        // } else {
                        //     self.$router.push({path: localStorage.getItem('last_url')});
                        // }

                    }

                    // Modals.show_danger_modal('sss',"sdsddd",[]);


                }).catch(function (error) {
                    self.loading = false;

                });

            },
            forgot_password() {
                if (this.user == "") {
                    this.$refs.modal.show_danger_modal(this.$t("dialogs.error"), this.$t('dialogs.insertMobile'));
                    return;
                }
                let self = this;
                self.loading = true;
                const formData = new FormData();
if(this.forgot_password_number.includes("@")){
    formData.append('mobileNo', "");
    formData.append('eMail', this.forgot_password_number);
}else{
    formData.append('mobileNo', this.forgot_password_number);
    formData.append('eMail', "");
}
                delete axios.defaults.headers.post["Authorization"];
                axios.post("ForgotPassword", formData, {}).then((res) => {
                    self.loading = false;

                    // console.log(res.headers.value('token'));
// res.headers.value('token');
                    if (res.data.statusCode != 0) {
                        this.$refs.modal.show_danger_modal(this.$t("dialogs.error"), res.data.message);
                    } else {
                        this.$refs.modal.show_api_response_modals(this.$t("dialogs.error"), res);
                    }

                    // Modals.show_danger_modal('sss',"sdsddd",[]);


                }).catch(function (error) {
                    self.loading = false;

                });

            }
        }
    }


</script>
